import { render, staticRenderFns } from "./BannerSwiper.vue?vue&type=template&id=707116a7&scoped=true"
import script from "./BannerSwiper.vue?vue&type=script&lang=js"
export * from "./BannerSwiper.vue?vue&type=script&lang=js"
import style0 from "./BannerSwiper.vue?vue&type=style&index=0&id=707116a7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707116a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('707116a7')) {
      api.createRecord('707116a7', component.options)
    } else {
      api.reload('707116a7', component.options)
    }
    module.hot.accept("./BannerSwiper.vue?vue&type=template&id=707116a7&scoped=true", function () {
      api.rerender('707116a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/components/BannerSwiper.vue"
export default component.exports